// Minimal markdown-light renderer: paragraphs, **bold**, *italic*, line breaks.
function renderInline(text) {
  // Escape HTML
  let safe = String(text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  // Bold + italic
  safe = safe.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  safe = safe.replace(/\*(.+?)\*/g, "<em>$1</em>");
  // Links: [label](url)
  safe = safe.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g,
    '<a href="$2" class="underline" style="color:var(--wp-olive)">$1</a>'
  );
  return safe;
}

export default function TextBlock({ data }) {
  const body = (data && data.body) || "";
  const paragraphs = body.split(/\n{2,}/).filter(Boolean);
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <div className="space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--wp-text)" }}>
          {paragraphs.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: renderInline(p).replace(/\n/g, "<br/>") }} />
          ))}
        </div>
      </div>
    </section>
  );
}
